import { render, staticRenderFns } from "./image_text_widget.vue?vue&type=template&id=3d0fb637&scoped=true&lang=pug"
import script from "./image_text_widget.vue?vue&type=script&lang=js"
export * from "./image_text_widget.vue?vue&type=script&lang=js"
import style0 from "./image_text_widget.vue?vue&type=style&index=0&id=3d0fb637&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0fb637",
  null
  
)

export default component.exports